import { ListCustomerGroups } from "../modules";

export const ListCustomerGroupsPage = () => {
  return <ListCustomerGroups />;
};
